import React from 'react'
import Modal from './Modal';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSystemModel } from '../../lib/redux/slices/controlSlice';
import { Replace } from 'lucide-react';
import ReplacePlayerModal from './ReplacePlayerModal';
import ModalFactoryGenerator from './ModalFactoryGenerator';

type Props = {}

function ModalFactory({}: Props) {
    const systemModelState = useSelector((state:any) => state.control.SystemModelOpen);
    const systemModalType = useSelector((state:any) => state.control.SystemModelType);
    const systemModalInfo = useSelector((state:any) => state.control.SystemModelInfo);
    const dispatch = useDispatch();
    const closeSystemModel = () => {
        //@ts-ignore
        dispatch(toggleSystemModel({state:false}))
    }
  return (
     <Modal
                  isOpen={systemModelState}
                  onClose={() => {
                       closeSystemModel()
                  }}
                  modalMaxWidth='max-w-[500px]'
                >
                 <ModalFactoryGenerator modalType={systemModalType} data={systemModalInfo} closeFunction={closeSystemModel} />
                </Modal>
  )
}

export default ModalFactory